import { Injectable, Inject } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError, of } from 'rxjs'
import { catchError, take } from 'rxjs/operators'
import { HttpErrorHandler, resolveApplicable } from '@spartacus/core'
import { Actions, ofType } from '@ngrx/effects'
import { Router } from '@angular/router'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import { CommonService } from '../services/common.service'
import { BulkServiceService } from '../../features/bulk-order/bulk-service.service'
import { QuoteCartService } from '../../features/quote/quote-services/quote-cart.service'

@Injectable()
export class CartErrorInterceptor implements HttpInterceptor {
  public cartId
  public redirectPage = ''
  public reuestBody: any
  public redirectPLP: any
  public userType: string
  constructor(
    @Inject(HttpErrorHandler) protected handlers: HttpErrorHandler[],
    private multiCartService: MultiCartFacade,
    private actions$: Actions,
    protected cartService: ActiveCartFacade,
    private bulkService: BulkServiceService,
    private quoteService: QuoteCartService,
    public commonService: CommonService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: any) => {
        if (response instanceof HttpErrorResponse) {
          this.handleErrorResponse(request, response)
          return throwError(response)
        }
      })
    )
  }

  protected handleErrorResponse(
    request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.redirectPage = request.url
    this.reuestBody = request.body
    this.redirectPLP = this.router.url
    if (
      (response.error.errors[0].message == 'Cart not found.' &&
        request.url.includes('/count')) ||
      request.url.includes('/vsentries')
    ) {
      this.multiCartService.createCart({
        userId: 'current',
        extraData: {
          active: true,
        },
      })
      this.actions$
        .pipe(ofType(CartActions.CREATE_CART_SUCCESS), take(1))
        .subscribe((res: any) => {
          this.cartId = res.payload.cartId
          console.log('cart id generated', this.cartId)
          this.multiCartService.loadCart({
            userId: 'current',
            cartId: this.cartId,
            extraData: {
              active: true,
            },
          })
          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
            .subscribe((res) => {
              if (this.redirectPage.includes('/count')) {
                this.bulkService.newCartId.next(true)
              } else if (
                this.redirectPLP.includes('/check-price-availability')
              ) {
                this.bulkService.vsntriesCart.next(true)
              } else if (!this.redirectPLP.includes('/product')) {
                this.bulkService.buyPLPCart.next(true)
              } else if (this.redirectPage.includes('/vsentries')) {
                this.bulkService.vsntriesCart.next(true)
              }
            })
        })
    } else if (
      (response.error.errors[0].message ==
        'Parameter parameters.cart can not be null' &&
        request.url.includes('/entries')) ||
      (response.error.errors[0].message ==
        'The application has encountered an error' &&
        request.url.includes('/count')) ||
      (response.error.errors[0].message ==
        'The application has encountered an error' &&
        request.url.includes('/quotecheckout')) ||
      (response.error.errors[0].message ==
        'The application has encountered an error' &&
        request.url.includes('/anonymous'))
    ) {
      this.userType = 'current'
      this.cartId = sessionStorage.getItem('cartId-current')
      this.quoteService
        .getCart(this.cartId, this.userType)
        .pipe(take(1))
        .subscribe((success) => {
          this.cartId = success['code']
          console.log('quote cart gerenated', this.cartId)
          sessionStorage.setItem('cartId-' + this.userType, this.cartId)
          sessionStorage.setItem('cartStatus-' + this.userType, 'added')

          let quoteCartValue = this.cartId
          this.quoteService.recieveCartId.pipe(take(1)).subscribe((cartId) => {
            if (cartId) {
              this.cartId = quoteCartValue
              const urlParam = [
                'users',
                this.userType,
                'rfqcart',
                this.cartId,
                'entries',
              ]
              const apiUrl = this.commonService.constructUrl(urlParam)
              return this.commonService.postData(apiUrl, this.cartId)
            }
          })
          if (this.redirectPLP.includes('/check-price-availability')) {
            this.bulkService.quoteDialogId.next(true)
          } else if (this.redirectPLP.includes('/product')) {
            this.bulkService.productQuoteDialog.next(true)
          } else if (
            this.redirectPage.includes('/entries') &&
            this.redirectPLP.includes('/quote/cart')
          ) {
            this.bulkService.newQuoteId.next(true)
          } else if (
            this.redirectPage.includes('/entries') &&
            this.redirectPLP.includes('/')
          ) {
            this.bulkService.requestQuoteDialog.next(true)
          } else if (this.redirectPLP.includes('/quote/checkout')) {
            this.bulkService.quoteCheckoutId.next(true)
          } else if (this.redirectPage.includes('/count')) {
            this.bulkService.bulkQuoteCartId.next(true)
          }
        })
    }
  }

  /**
   * return the error handler that matches the `HttpResponseStatus` code.
   * If no handler is available, the UNKNOWN handler is returned.
   */
  protected getResponseHandler(response: HttpErrorResponse): HttpErrorHandler {
    return resolveApplicable(this.handlers, [response])
  }
}
